/* JUCE install - the shop as an app, on the Home Screen, called JUCE.
 *
 * WHAT THIS ACTUALLY IS. There is no store listing and no native build. A
 * web app manifest (assets/manifest.json) tells the browser that juce.co.za
 * has a name, an icon and a window of its own, and the browser does the
 * rest: on Android and on desktop Chromium an installed JUCE gets its own
 * launcher icon, its own task in the switcher and no address bar; on an
 * iPhone the same manifest is what makes the Home Screen copy open as a web
 * app rather than a Safari tab. The icon is the wordmark on white
 * (assets/icon-*.png, rendered from the shipped Fredoka file at
 * letter-spacing 0, which is the only face the mark is ever allowed to
 * wear), in two shapes: the plain one, and a maskable one whose mark sits
 * inside the circle Android crops to, so no rounded launcher can clip it.
 *
 * THE THEME USED TO REFUSE THIS ON PURPOSE, and the head said so: one icon
 * in the manifest, short of Chrome's two-size rule, and a
 * beforeinstallprompt that was cancelled the moment it arrived, "which
 * nobody asked for". Somebody has now asked for it (owner, 2026-09-12: "Is
 * it possible to make our Shopify store a installable app with the juce
 * logo"). So the manifest is a real one and the event is CAUGHT rather than
 * thrown away: caught, because a browser that offers the install once and is
 * ignored may not offer it again, and because the offer has to wait for the
 * cookie banner to be answered first. window.__juceBip in the head holds it
 * until this module is running (a deferred module cannot be the listener:
 * the event fires while theme.js is still downloading).
 *
 * WHEN IT ASKS, AND HOW OFTEN. Never before the cookie banner has been
 * answered (owner: "the install request only happens after they consented or
 * essential or whatever"), never on the first page, never in the cart or the
 * checkout, never while the cookie card or the push card is on screen - two
 * questions at once is how neither gets read; on an iPhone, never before the
 * second visit (2026-09-23, see eligible). Then: TWICE, EVER, thirty days
 * apart, and never again. An install is a bigger ask than a notification and
 * the answer does not change by being asked a third time; the footer's own
 * door (data-install-open) is there for anybody who changes their mind.
 *
 * ANDROID AND DESKTOP GET A REAL BUTTON. The stashed event has one prompt()
 * in it, the browser's own sheet opens on the tap, and the answer is counted
 * accepted or dismissed. An iPHONE GETS THREE TAPS INSTEAD, because Apple
 * has never given the web a programmatic install: Share, Add to Home Screen,
 * Add. That lane is Safari only, and it is the same lane the push card
 * already explains when the reason for installing is notifications.
 *
 * AND IT KNOWS WHEN IT IS ALREADY THE APP. A page running in an installed
 * window (display-mode standalone, minimal-ui or fullscreen, or Apple's
 * navigator.standalone) never asks, files itself as installed, and tells
 * LOOM once a session that this visit arrived through the app
 * (app.open, and app.install for the moment it happened). That is the
 * "loaded it as a app or not" the shop wanted to be able to see, and it is
 * the same for every browser: an observation about the window, not an id.
 */
(function () {
  'use strict';
  const conf = (window.theme && window.theme.install) || null;
  if (!conf || !conf.enabled) return;

  /* Counting rides the push host, because it is already the thing that
     counts the other card and the two funnels are read side by side. No
     endpoint means no counting, and the card still works. */
  let ORIGIN = '';
  try { ORIGIN = conf.endpoint ? new URL(conf.endpoint).origin : ''; } catch (e) { ORIGIN = ''; }

  const ua = navigator.userAgent || '';
  const ios = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
  const inApp = /Instagram|FBAN|FBAV|FB_IAB|TikTok|musical_ly|WhatsApp|Line\/|Snapchat|Pinterest/i.test(ua);
  const chromish = /Chrome\/|Chromium\/|CriOS\//i.test(ua);
  const firefox = /Firefox\//i.test(ua) || /FxiOS\//i.test(ua);
  /* On iOS every browser is WebKit, but only Safari's share sheet carries
     Add to Home Screen. Chrome and Firefox there would be sent to a menu
     item that does not exist. */
  const iosSafari = ios && !chromish && !firefox && !inApp;

  /* WHICH WINDOW THIS IS. display-mode is the standard answer and covers
     Android, desktop and iOS 26; navigator.standalone is Apple's older one
     and is the only answer on iOS before 26.
     ONLY THE TWO MODES THE MANIFEST CAN OPEN IN (2026-09-23). This used to
     count 'fullscreen' and any android-app:// referrer (read as a trusted
     web activity) as the app too, and LOOM showed what that bought: of 223
     "installed" in eleven days, 70 were an android-app:// referrer - the
     Instagram, Facebook and Google apps set exactly that on the page they
     open, and JUCE has no Play Store build for it to be - and 40 were
     'fullscreen', which is TikTok's ad webview (pangleglobal.com) and a Mac
     Chrome window in full screen. Neither is the app: the manifest opens
     JUCE standalone, or minimal-ui where a browser cannot. So those two
     modes are the app and nothing else is, and an in-app browser never is,
     whatever it reports. */
  function displayMode() {
    try {
      if (inApp) return 'browser';
      const mm = window.matchMedia;
      if (mm) for (const m of ['standalone', 'minimal-ui']) {
        if (mm('(display-mode: ' + m + ')').matches) return m;
      }
      if (navigator.standalone === true) return 'standalone';
    } catch (e) { /* a browser that cannot say is a browser */ }
    return 'browser';
  }
  const mode = displayMode();
  const running = mode !== 'browser';

  const STORE = 'juce:inst:v1';
  const PV = 'juce:inst:pv';
  const DAY = 86400000;
  /* Thirty days between the two asks, and the second one is the last. */
  const WAIT = 30 * DAY;
  const MAX_ASKS = 2;
  /* Pages seen, across visits, before the shop asks to be kept. Somebody who
     has looked at three pages has decided to be here, which is the "value
     moment" every guide to this names and the thing Chrome's own advice asks
     for: give something before you ask for anything. It was four while this
     card was the second question of the visit; it is three now that it is
     the first one after the cookie banner, so the notification ask still has
     room to land later in the same browse rather than on top of it. */
  const PAGES = 3;

  function read() { try { return JSON.parse(localStorage.getItem(STORE) || '{}') || {}; } catch (e) { return {}; } }
  function write(patch) { try { localStorage.setItem(STORE, JSON.stringify(Object.assign(read(), patch))); } catch (e) { /* private mode */ } }

  /* THE BATON THE PUSH CARD READS (2026-09-12, owner: "we need it to flow
     nicely, cookie consent, then perhaps app? and while they browse
     notify"). Three questions in one visit is three refusals, and the order
     is not a matter of taste: an iPhone cannot receive a notification at all
     until the shop is on its Home Screen, so asking to notify first is
     asking for something that cannot be delivered. The app goes first, the
     notification follows once this question is done with.

     So this file publishes what it is going to do, and assets/juce-push.js
     stands down until it says the matter is closed:
       'offer' - there is an install to ask for, so push waits.
       'none'  - nothing to ask for on this browser (no offer from it, and
                 not an iPhone), so push may go ahead now.
     A settled answer - installed, or asked and answered once - releases push
     whatever the verdict says. It rides in the same mark as the rest so a
     browser with no storage simply falls back to the old order, which is
     the safe direction to fail in. */
  function verdict(v) { try { if (read().verdict !== v) write({ verdict: v }); } catch (e) { /* private mode */ } }

  /* A count and nothing else - no id, no cookie, nothing to join back - so
     it is the counting a refused banner still permits. Same door and same
     shape as the push card's. */
  function count(e) {
    if (!ORIGIN) return;
    try {
      fetch(ORIGIN + '/api/push/prompt', {
        method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: { 'content-type': 'application/json' }, body: JSON.stringify({ e: e }),
      }).catch(() => {});
    } catch (err) { /* nothing to count with */ }
  }
  /* LOOM's own door, the one the finder and the duet already use. It is
     consent-gated on the far side like every other event, which is why
     nothing here checks a grant: the tracker's fork does it. */
  function loom(name, props) {
    try {
      document.dispatchEvent(new CustomEvent('juce:loomview', { detail: { name: name, props: props || {} } }));
    } catch (e) { /* law 1 */ }
  }

  /* ------------------------------------------- already the app, or not */
  /* A visit that arrived in an installed window is the answer to "did they
     install it", and it is worth more than the install count: it is the
     retention. Counted once a session so a ten-page visit is one app open. */
  if (running) {
    const s = read();
    if (s.state !== 'in') { write({ state: 'in', at: Date.now(), mode: mode }); count('installed'); loom('app.install', { mode: mode, how: 'seen' }); }
    else if (s.mode !== mode) write({ mode: mode });
    /* WHICH DOOR OF THE APP THEY CAME IN AT. The manifest gives the icon
       three shortcuts of its own - shop, the finder, track a parcel - and
       each carries its own `from`, so a long-press launch says what they
       opened the app to do. The icon itself is 'home'. It is a query
       parameter and nothing more: anything unexpected is thrown away rather
       than filed. */
    const from = (function () {
      try {
        const v = new URL(location.href).searchParams.get('from') || '';
        return ['home', 'shop', 'finder', 'track'].indexOf(v) !== -1 ? v : null;
      } catch (e) { return null; }
    })();
    /* KEEP THE STORAGE. An installed app that loses its jar loses the
       visitor id, the consent answer and the push mark, and comes back as a
       stranger - which is exactly what a browser's routine eviction does to
       a site it thinks is idle. Asking is free and silent: an installed app
       is the case browsers grant it in, and a no changes nothing. */
    try { if (navigator.storage && navigator.storage.persist) void navigator.storage.persist().catch(() => {}); } catch (e) { /* fine */ }
    /* The count on the icon is for things waiting to be READ. Opening the
       app is reading them, so it goes now. */
    try { if (navigator.clearAppBadge) void navigator.clearAppBadge().catch(() => {}); } catch (e) { /* fine */ }
    try {
      if (!sessionStorage.getItem('juce:inst:open')) {
        sessionStorage.setItem('juce:inst:open', '1');
        /* How many times this device has opened the app, and when it last
           did. The install is one number; this is the one that says whether
           it was worth anything. */
        write({ opens: Number(s.opens || 0) + 1, openAt: Date.now() });
        count('app_open');
        loom('app.open', { mode: mode, from: from || undefined, opens: Number(read().opens || 1) });
      }
    } catch (e) { count('app_open'); }
    return;   /* nothing left to ask */
  }

  /* A MARK THE OLD GUESS WROTE, TAKEN BACK (2026-09-23). A Chrome that once
     opened juce.co.za from inside Instagram or Facebook (a Custom Tab shares
     Chrome's storage) was filed as installed on the strength of that
     referrer, and an installed browser is never offered the install. Only a
     real install says 'standalone', 'minimal-ui', 'accepted' or
     'installed', so any other 'in' seen from a plain tab is undone and this
     browser is asked like any other. Its asks are kept: nobody was asked. */
  (function repair() {
    const s = read();
    if (s.state === 'in' && (s.mode === 'twa' || s.mode === 'fullscreen')) write({ state: null, mode: null, at: 0 });
  })();

  /* VISITS, NOT PAGES (2026-09-23). A visit is a page more than half an hour
     after the last one. The iPhone's ask waits for the second visit - see
     eligible() - and this is the only thing that counts them. */
  const VISIT_GAP = 30 * 60000;
  (function visit() {
    const s = read();
    const now = Date.now();
    const fresh = !s.seenAt || now - Number(s.seenAt) > VISIT_GAP;
    write({ seenAt: now, visits: Number(s.visits || 0) + (fresh ? 1 : 0) });
  })();

  /* The browser's offer, stashed in the head before this module existed. */
  let bip = window.__juceBip || null;
  let card = null, shown = false, wearing = '';

  /* ARMED ONLY ONCE THE BOOT SAYS SO (fixed 2026-09-12, before this ever
     went out). The browser decides when to offer, and on a fast connection
     it can offer on the very first page, before the cookie banner has been
     answered - and this listener called maybe() straight out, which checks
     the state and the other cards but knows nothing about consent or how
     many pages have been seen. So a first-time visitor with a quick Chrome
     could have been shown the install card on page one over an unanswered
     cookie banner, which is exactly the thing that was not to happen (owner:
     "the install request only happens after they consented or essential or
     whatever"). The event is still caught the instant it arrives, because it
     comes once and is gone; it simply waits here until the boot below opens
     the gate. */
  let armed = false;
  window.addEventListener('beforeinstallprompt', (e) => {
    try { e.preventDefault(); } catch (err) { /* nothing to prevent */ }
    bip = e;
    window.__juceBip = e;
    verdict('offer');
    if (armed) maybe();
  });
  /* The install happened - through our card, through the browser's own menu,
     or through the mini-infobar on an older Chrome. All three end here. */
  window.addEventListener('appinstalled', () => {
    bip = null; window.__juceBip = null;
    write({ state: 'in', at: Date.now(), mode: 'installed' });
    count('installed');
    loom('app.install', { mode: displayMode(), how: 'event' });
    hide();
  });

  function pageviews() {
    let n = 0;
    try { n = Number(localStorage.getItem(PV) || 0) + 1; localStorage.setItem(PV, String(n)); } catch (e) { n = PAGES; }
    return n;
  }

  /* ------------------------------------------------------------- card */
  function $(sel) { return card ? card.querySelector(sel) : null; }
  /* THE CARD HAS NO HEADLINE ANY MORE (2026-09-12, owner: "it must be more
     like the chrome addon that says install as app tho.. that popup.. nor
     this messaging of it's own icon.... this is for the customer so the goal
     is to sell"). Where a browser's own install dialog puts a mark, a name
     and an address, the first build put a sentence about icons and address
     bars: four explanations of the machinery and not one reason to want it.
     So the top of the card is fixed markup now - the app icon, JUCE,
     juce.co.za - and the only words this function writes are the one line
     underneath, the steps where a browser needs them, and the buttons. */
  function view(o) {
    const b = $('[data-inst-body]'); if (b) b.textContent = o.body;
    const steps = $('[data-inst-steps]');
    if (steps) {
      steps.textContent = '';
      if (o.steps && o.steps.length) {
        for (const s of o.steps) { const li = document.createElement('li'); li.textContent = s; steps.appendChild(li); }
        steps.hidden = false;
      } else steps.hidden = true;
    }
    const acts = $('[data-inst-acts]');
    const go = $('[data-inst-go]');
    if (go && o.cta) { go.textContent = o.cta; go.hidden = false; if (acts) acts.hidden = false; }
    else { if (go) go.hidden = true; if (acts) acts.hidden = true; }
    const later = $('[data-inst-later]'); if (later) later.textContent = o.later || 'Not now';
  }
  function say(text, tone) {
    const el = $('[data-inst-status]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
    el.classList.toggle('is-bad', tone === 'bad');
  }
  /* The card sits where the push card sits, so it lifts above the dock the
     same way. */
  function lift() {
    if (!card) return;
    const dock = document.querySelector('.dock');
    const apply = () => {
      const h = dock ? Math.round(dock.getBoundingClientRect().height) : 0;
      card.style.setProperty('--pushp-lift', (h > 0 ? h : 0) + 'px');
    };
    apply();
    if (dock && 'ResizeObserver' in window) new ResizeObserver(apply).observe(dock);
  }
  function show(face) {
    if (!card || !card.hidden) return;
    lift();
    card.hidden = false;
    void card.offsetHeight;
    card.classList.add('is-up');
    if (shown) return;
    shown = true;
    /* ONE ASK IS ONE ASK, NOT ONE PAGE (fixed 2026-09-12, before this ever
       went out). A card that comes up and is not answered stays up across
       pages, which is deliberate - but the counter sat here unguarded, so
       every page view of the same unanswered card spent another of the two
       asks and added another 'shown'. Two pages and the ceiling was gone;
       the offer would have looked like it was asked twice and refused twice
       by somebody who never touched it. The standing state is the guard: it
       says 'showing' from the first page, and only an answer clears it. */
    const s = read();
    if (s.state === 'showing') return;
    write({ asks: Number(s.asks || 0) + 1, at: Date.now(), state: 'showing' });
    count('install_shown');
    if (face) count(face);
  }
  function hide() {
    if (!card || card.hidden) return;
    card.classList.remove('is-up');
    const done = () => { card.hidden = true; };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else setTimeout(done, 220);
  }
  function later(state) {
    write({ state: state || 'later', at: Date.now() });
    count('install_later');
    hide();
  }

  /* ONE LINE, AND IT IS ABOUT THE SHOPPER. What is in it for somebody who
     buys scent is being early to a new one and not having to find the shop
     again; that is the whole offer, and the browser's own sheet says the
     rest a second later. */
  function offer() {
    wearing = 'button';
    view({ body: 'New scents first, and a faster way back in.', cta: 'Install', later: 'Not now' });
    say('');
  }
  /* An iPhone outside an installed window. Apple gives the web no install
     call at all, so the three taps ARE the sheet: there is no dialog coming
     after this one to explain anything, which is the one place the card has
     to say more than a browser would. */
  function apple() {
    wearing = 'ios';
    view({
      body: 'New scents first, and a faster way back in. Three taps:',
      steps: [
        'Tap the Share button at the bottom of Safari.',
        'Scroll to Add to Home Screen, then tap it.',
        'Tap Add.',
      ],
      cta: null, later: 'Not now',
    });
    say('');
  }

  /* -------------------------------------------------------- the answer */
  async function go() {
    /* iOS has no button: the steps are the answer. */
    if (wearing === 'ios') { later('later'); return; }
    if (!bip) { later('later'); return; }
    count('install_go');
    say('');
    let outcome = '';
    try {
      const p = bip.prompt();
      /* Chrome resolves prompt() with the choice; older builds only settle
         userChoice. Ask both and take whichever answers. */
      const choice = await (p && typeof p.then === 'function' ? p : bip.userChoice);
      outcome = String((choice && choice.outcome) || (await bip.userChoice.then((c) => c && c.outcome).catch(() => '')) || '');
    } catch (e) {
      /* A prompt that was already used, or a browser that withdrew it. */
      outcome = '';
    }
    bip = null; window.__juceBip = null;
    if (outcome === 'accepted') {
      count('install_ok');
      write({ state: 'in', at: Date.now(), mode: 'accepted' });
      loom('app.install', { mode: 'accepted', how: 'prompt' });
      hide();
      return;
    }
    /* Dismissed, or a browser that would not say. Either way the offer is
       spent for thirty days, and the browser will not hand the event back
       until the next page anyway. */
    count('install_no');
    write({ state: 'later', at: Date.now() });
    hide();
  }

  /* ------------------------------------------------------------ timing */
  function eligible() {
    if (!card) return false;
    if (inApp) return false;                       /* no install in an in-app browser */
    if (/^\/(cart|checkouts?|account\/login|account\/register|password)/.test(location.pathname)) return false;
    const s = read();
    if (s.state === 'in') return false;            /* already the app */
    if (Number(s.asks || 0) >= MAX_ASKS) return false;  /* asked twice, that is enough */
    if (s.state === 'showing') return true;        /* put up on an earlier page, still unanswered */
    if (s.at && Date.now() - Number(s.at) < WAIT) return false;
    /* AN iPHONE IS ASKED ON ITS SECOND VISIT, NOT ITS FIRST (2026-09-23,
       owner: "not to bombard the users with things or give them manual
       instructions"). The iPhone face is the one card in this system that
       is instructions, because Apple gives the web no install call, and the
       numbers say who it was being read by: 524 shown in eleven days, 489
       "Not now", and about one real install - nearly all of it to somebody
       on their first visit, in from an ad. Somebody who comes back has
       decided the place is worth coming back to, which is the person a
       Home Screen icon is for. Android and desktop keep the page count:
       their card is one tap on the browser's own sheet, with nothing to
       read. */
    if (iosSafari && !bip && Number(s.visits || 0) < 2) return false;
    return true;
  }
  /* Neither the cookie card nor the push card may share the screen with
     this one. The push offer goes first where both could: a notification is
     the cheaper yes and the one the shop can act on. */
  function busy() {
    const g = document.querySelector('[data-gate]');
    const p = document.querySelector('[data-gate-panel]');
    const push = document.querySelector('[data-pushp]');
    if (g && !g.hidden) return true;
    if (p && p.open) return true;
    if (push && !push.hidden) return true;
    return false;
  }
  if ('MutationObserver' in window) {
    const watch = new MutationObserver(() => { if (busy()) hide(); });
    for (const sel of ['[data-gate]', '[data-gate-panel]', '[data-pushp]']) {
      const el = document.querySelector(sel);
      if (el) watch.observe(el, { attributes: true, attributeFilter: ['hidden', 'open', 'class'] });
    }
  }
  function whenDecided(cb) {
    const jc = window.juceConsent || null;
    if (!jc || jc.state !== 'undecided') { cb(); return; }
    /* ONLY AN ANSWER COUNTS (2026-09-14): the "measured on notice" event
       arrives with state 'undecided' while the banner is still open, and must
       not bring this card up over it. Same fix as juce-push.js. */
    document.addEventListener('juce:consent', function once(e) {
      const st = e && e.detail && e.detail.state;
      if (st === 'undecided') return;
      document.removeEventListener('juce:consent', once);
      cb();
    });
  }

  let tries = 0;
  function maybe(force) {
    if (!card || !card.hidden) return;
    if (!force && !eligible()) return;
    if (!force && busy()) {
      /* Wait out the other card rather than fighting it; a handful of
         tries, then leave it for the next page. */
      if (tries++ > 20) return;
      setTimeout(() => maybe(false), 1500);
      return;
    }
    if (bip) { offer(); show('install_android'); return; }
    if (iosSafari) { apple(); show('install_ios'); return; }
    /* No offer from the browser and not an iPhone: there is nothing to ask
       for. A Chrome that has not decided this page is installable yet will
       fire beforeinstallprompt later and come back through here. */
  }

  /* --------------------------------------------------------------- boot */
  card = document.querySelector('[data-inst]');
  if (!card) return;

  card.addEventListener('click', (e) => {
    const t = e.target && e.target.closest ? e.target.closest('[data-inst-go], [data-inst-later]') : null;
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-inst-go')) void go();
    else later(wearing === 'ios' ? 'later' : 'later');
  });

  /* A door of its own, for the footer. A tap here has already decided, so
     it ignores every timing rule - but not the two-ask ceiling's purpose:
     a door is not an ask, so it is not counted as one. */
  document.addEventListener('click', (e) => {
    const t = e.target && e.target.closest ? e.target.closest('[data-install-open]') : null;
    if (!t) return;
    e.preventDefault();
    count('install_door');
    if (bip) offer();
    else if (iosSafari) apple();
    else {
      wearing = 'menu';
      view({
        body: 'Open your browser menu and choose Install app, or Add to Home screen.',
        cta: null, later: 'Got it',
      });
    }
    shown = true;   /* a door never spends one of the two asks */
    if (card.hidden) { lift(); card.hidden = false; void card.offsetHeight; card.classList.add('is-up'); }
  });

  /* THE FOOTER'S DOOR, SHOWN ONLY WHERE IT LEADS SOMEWHERE. It ships hidden
     because a door that cannot open is worse than no door: an in-app browser
     has no install at all, and a device that is already the app went home
     before this line. Everything else has something behind it - the
     browser's own sheet, Apple's three taps, or at worst the browser menu
     the card names - so it comes up. */
  function openDoor() {
    if (inApp) return;
    document.querySelectorAll('[data-install-open]').forEach((el) => { el.hidden = false; });
  }
  openDoor();

  /* What this browser can be asked, said now rather than when the card comes
     up, because the push card needs the answer before either of them shows.
     An iPhone is 'offer' on sight - Apple never fires the event and the
     three taps are always available. Anything else waits on the browser: the
     event usually arrives within a moment of load, and until it does the
     honest answer is that there is nothing to offer. A late arrival rewrites
     it above. */
  verdict(bip || iosSafari ? 'offer' : 'none');

  const pv = pageviews();
  whenDecided(() => {
    const s = read();
    /* A card put up on an earlier page and never answered comes straight
       back, with no page count and no wait, exactly as the push card does. */
    if (s.state !== 'showing' && pv < PAGES) return;
    armed = true;
    maybe(false);
  });
})();
